/** @jsx jsx */
import { css } from '@emotion/core';

import { Theme } from 'features/Theme';

const disabledBackgroundForTheme = (theme: Theme) => {
  return theme.mui.palette.type === 'light'
    ? 'rgba(0, 0, 0, 0.09)'
    : 'rgba(255, 255, 255, 0.09)';
};

const styles = {
  textField: (theme: Theme) => {
    // Stylings here are lifted from the Mui's OutlinedInput.
    const padding = theme.mui.spacing(1);
    const labelSpace = theme.mui.spacing(2);

    return css`
      // Make the input itself taller to accommodate
      // the label (instead of using margin). This allows
      // the input background color to cover the label.

      & label + .MuiInput-formControl {
        margin-top: 0;
      }
      & .MuiInputBase-root {
        &.Mui-disabled::before {
          border-bottom-style: solid;
        }
        .MuiInputBase-input {
          padding: ${padding}px;
          padding-top: ${padding + labelSpace}px; // leave space for label
        }
        .MuiInputBase-input.Mui-disabled {
          background-color: ${disabledBackgroundForTheme(theme)};
        }
        .MuiInputBase-input::-webkit-input-placeholder {
          // Improve contrast with white background for better accessibility.
          opacity: 0.65;
        }
      }

      & .MuiFormHelperText-root {
        margin-left: ${padding}px;
      }
      & .MuiInputLabel-formControl {
        z-index: 1;
        margin-left: ${padding}px;
        pointer-events: none;
      }
      & .MuiInputLabel-shrink {
        top: ${padding}px;
      }
    `;
  },
};

export default styles;
